import { render, staticRenderFns } from "./update-domain.vue?vue&type=template&id=7fbb90f7&"
import script from "./update-domain.vue?vue&type=script&lang=js&"
export * from "./update-domain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports